import { render } from "./MembersPage.vue?vue&type=template&id=47b0298a&scoped=true"
import script from "./MembersPage.vue?vue&type=script&lang=js"
export * from "./MembersPage.vue?vue&type=script&lang=js"

import "./MembersPage.vue?vue&type=style&index=0&id=47b0298a&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b0298a"]])

export default __exports__